import { __assign, __read, __rest } from "tslib";
import React, { useState, useCallback } from 'react';
import { Box, Flex, Icon, Input, Position, SearchCloseButton, } from '@marvelapp/ui';
import { SEARCH_ICON } from '@marvelapp/theme';
/** @param {any} */
export default function Filter(_a) {
    var placeholder = _a.placeholder, _b = _a.kind, kind = _b === void 0 ? 'design' : _b, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["placeholder", "kind", "value", "onChange"]);
    var _c = __read(useState(false), 2), isFocussed = _c[0], setIsFocussed = _c[1];
    var handleOnClear = useCallback(function () {
        onChange('');
    }, [onChange]);
    return (React.createElement(Box, { borderTop: "1px solid", 
        // eslint-disable-next-line
        borderColor: "smoke", "data-testid": "filter-input", height: 40 },
        React.createElement(Position, null,
            React.createElement(Flex, { alignItems: "center", height: 40, justifyContent: "center", left: 10, position: "absolute", top: 0 },
                React.createElement(Icon, { display: "block", fill: isFocussed ? 'marvelDark' : 'black', height: 18, paths: SEARCH_ICON, width: 18 })),
            React.createElement(Position, null,
                React.createElement(Input, __assign({ borderRadius: "0px", "data-testid": "filter-input-field", fontSize: 12, height: 40, kind: kind, mt: "-1px", onBlur: function () { return setIsFocussed(false); }, onChange: function (e) { return onChange(e.target.value); }, onFocus: function () { return setIsFocussed(true); }, pl: 35, placeholder: placeholder, value: value, width: 1 }, props)),
                value && (React.createElement(SearchCloseButton, { onClick: handleOnClear, onMouseDown: function (e) { return e.preventDefault(); } }))))));
}
